import AddVariant from "../AddVariant";
import AddedVariants from "../AddedVariants/Index";
import Table from "../Table";
import "./ItemDetail.scss";

import Modal from "../common/Modal/Modal";
import useModal from "../../utils/hooks/useModal";
import { useEffect, useState } from "react";
import { useCart } from "../../context/CartContext";
import { Icon } from "../Icon";
import TopShadow from "../common/TopShadow";
import { SingleValue } from "react-select";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import HomeCatalogDesktop from "../HomeCatalogDesktop";
import { Link, useLocation } from "react-router-dom";
import { ProductServices } from "../../services/products";
import { displayMoney } from "../../utils/displayMoney";

type Props = {
  product: Product;
  variations: Variation[];
  manufacturingCost: ManufacturingCost[];
  carousel?: CarouselExtended;
  isAuth: boolean;
};
const ItemDetail: React.FC<Props> = ({
  product,
  variations,
  manufacturingCost,
  carousel,
  isAuth,
}) => {
  const { addToCart, setLastProductAdded, cart } = useCart();
  const { isOpen, toggle } = useModal();
  const [images, setImages] = useState<string[]>(
    product.thumbnailUrl.split("|")
  );
  const [mainImage, setMainImage] = useState<string>(images[0]);
  const labels: LenghtLabel = ProductServices.getProductsLabels(
    product.category,
    product.department,
    product.isCustom
  );

  const location = useLocation();
  // REFACTOR THIS IN THE FUTURE, this should be a
  // new PreCartContext that's implemented at the item level instead of the whole app level, there's too much logic on this component

  // everything related to table should be a different component, keep it inside of item detail container but it's a static part
  // of the product view, so why keep it rerendering when we change te rest of the things? also helps with clear coding
  const [table, setTable] = useState<string[][]>([]);
  const [gauges, setGauges] = useState<string[]>([]);
  const [lengths, setLengths] = useState<string[]>([]);
  const [colors, setColors] = useState<string[]>([]);
  const [exist, setExist] = useState<boolean>(false);
  const [isLoginRequired, setIsLoginRequired] = useState<boolean>(false);
  const [incomplete, setIncomplete] = useState<boolean>(false);
  const [variation, setVariation] = useState<Variation>({
    weight: "",
    length: "",
    color: "",
    gauge: "",
    productId: product._id || "",
    manufacturingCostId: "",
  });
  const [preCart, setPreCart] = useState<CartProduct[]>([]);
  const [addOneProduct, setaddOneProduct] = useState<CartProduct>({
    ...product,
    weight: "",
    length: "",
    color: "",
    gauge: "",
    productId: product._id || "",
    manufacturingCostId: "",
    quantity: 1,
    manufacturValue: 0,
  });

  const handleVariationCounter = (preCart: CartProduct[]) => {
    return preCart.reduce((acc, curr) => {
      return acc + curr.quantity;
    }, 0);
  };

  useEffect(() => {
    if (variation.color != addOneProduct.color) {
      let gaugesAux: string[] = [];
      let lengthAux: string[] = [];
      variations.forEach((el) => {
        if (el.color == variation.color) {
          !gaugesAux.some((some) => some == el.gauge) &&
            gaugesAux.push(el.gauge);
          !lengthAux.some((some) => some == el.length) &&
            lengthAux.push(el.length);
        }
      });
      setGauges(gaugesAux.sort());
      setLengths(lengthAux.sort());

      let weights: string[][] = [];
      for (let j = 0; j < gaugesAux.length; j++) {
        let arrayAuxiliar: string[] = [];
        arrayAuxiliar.push(gaugesAux[j]);
        for (let i = 0; i < lengthAux.length; i++) {
          let found = variations.find(
            (el) => el.gauge == gaugesAux[j] && el.length == lengthAux[i]
          );
          found?.weight
            ? arrayAuxiliar.push(found?.weight)
            : arrayAuxiliar.push(" ");
        }
        weights.push(arrayAuxiliar);
        setTable(weights);
      }
    }

    let tempVariation =
      variations.filter((el) => el.color == variation.color).length == 1
        ? variations.find((el) => el.color == variation.color)
        : variations.find(
            (el) =>
              el.color == variation.color &&
              el.gauge == variation.gauge &&
              el.length == variation.length
          );

    // also, if we need all this info in 1, we can create a new endpoint for this.
    let addOneProductTemp: CartProduct = {
      ...product,
      ...variation,
      quantity: addOneProduct.quantity,
      manufacturingCostId: tempVariation?.manufacturingCostId || "",
      weight: tempVariation?.weight || "",
      manufacturValue:
        manufacturingCost.find(
          (el) => el._id == tempVariation?.manufacturingCostId || ""
        )?.value || 0,
      _id: tempVariation?._id || "",
    };
    setaddOneProduct(addOneProductTemp);
    tempVariation &&
      tempVariation._id != variation._id &&
      setVariation({ ...variation, ...tempVariation });
  }, [variation]);

  useEffect(() => {
    // this should be on new functions or helpers to construct this.
    // as it is, this becomes untesteable
    resetVariation();
    let weights: string[][] = [];
    let gaugesAux: string[] = [];
    let lengthAux: string[] = [];
    let colorsAux: string[] = [];
    variations.forEach((el) => {
      !gaugesAux.some((some) => some == el.gauge) && gaugesAux.push(el.gauge);
      !lengthAux.some((some) => some == el.length) && lengthAux.push(el.length);
      !colorsAux.some((some) => some == el.color) && colorsAux.push(el.color);
    });
    setGauges(gaugesAux.sort());
    setLengths(lengthAux.sort());
    colorsAux.sort();
    let colorWhite: string[] = [];
    let restColors: string[] = [];
    colorsAux.forEach((color) => {
      color == "blanco" ? colorWhite.push(color) : restColors.push(color);
    });
    setColors(restColors.concat(colorWhite));
    for (let j = 0; j < gaugesAux.length; j++) {
      let arrayAuxiliar: string[] = [];
      arrayAuxiliar.push(gaugesAux[j]);
      for (let i = 0; i < lengthAux.length; i++) {
        let found = variations.find(
          (el) => el.gauge == gaugesAux[j] && el.length == lengthAux[i]
        );
        found?.weight
          ? arrayAuxiliar.push(found?.weight)
          : arrayAuxiliar.push(" ");
      }
      weights.push(arrayAuxiliar);
      setTable(weights);
    }
  }, []);

  const sumItem = (e: any) => {
    e.preventDefault();
    setaddOneProduct({
      ...addOneProduct,
      quantity: addOneProduct.quantity + 1,
    });
  };
  const restItem = (e: any) => {
    e.preventDefault();
    addOneProduct.quantity - 1 > 0 &&
      setaddOneProduct({
        ...addOneProduct,
        quantity: addOneProduct.quantity - 1,
      });
  };

  const handleChange = (e: any) => {
    if (e.currentTarget.name !== "customization") {
      setVariation({
        ...variation,
        [e.currentTarget.name]: e.currentTarget.value,
      });
    }
  };

  const handleCreateCustomization = (newCustomization: string | undefined) => {
    setVariation({
      ...variation,
      customization: newCustomization,
    });
  };

  const handleEraseCustomization = () => {
    setVariation({
      ...variation,
      customization: "",
    });
  };

  const handleSelectChange = (
    selectedOption: SingleValue<{ value: string; label: string }>,
    e: any
  ) => {
    if (e.name == "color") {
      setVariation({
        ...variation,
        [e.name]: selectedOption?.value,
        length: "",
        gauge: "",
      });
    } else {
      setVariation({
        ...variation,
        [e.name]: selectedOption?.value,
      });
    }
  };

  const manageCart = () => {
    setaddOneProduct({
      ...product,
      _id: "",
      weight: "",
      length: "",
      color: "",
      gauge: "",
      productId: product._id || "",
      manufacturingCostId: "",
      quantity: 1,
      manufacturValue: 0,
    });
    resetVariation();
    setLastProductAdded({
      title: preCart[0]?.title ?? "",
      thumbnailUrl: preCart[0]?.thumbnailUrl ?? "",
      variations: handleVariationCounter(preCart),
    });
    preCart.forEach((c) => {
      addToCart({
        variationId: c._id as string,
        quantity: c.quantity,
        customization: c.customization,
      });
    });

    setPreCart([]);
  };

  const removeItem = (id: string) => {
    setPreCart(preCart.filter((el) => el._id != id));
  };

  const addPreCart = () => {
    const variationExist =
      cart?.variations?.length ?? 0 > 0
        ? cart?.variations?.some((x) => x.variation.id === addOneProduct._id)
        : false;

    if (addOneProduct._id == "") {
      setIncomplete(true);
    } else {
      setIncomplete(false);
      if (preCart.some((el) => el._id == addOneProduct._id) || variationExist) {
        setExist(true);
      } else {
        setExist(false);
        setPreCart([...preCart, addOneProduct]);
        setaddOneProduct({
          ...product,
          _id: "",
          weight: "",
          length: "",
          color: "",
          gauge: "",
          productId: product._id || "",
          manufacturingCostId: "",
          quantity: 1,
          manufacturValue: 0,
        });
        resetVariation();
      }
    }
  };
  // container logic and presentational on the same component is not a good idea.

  const resetVariation = () => {
    setVariation(
      variations.length === 1
        ? {
            weight: variations[0].weight,
            length: variations[0].length,
            color: variations[0].color,
            gauge: variations[0].gauge,
            productId: product._id || "",
            manufacturingCostId: variations[0].manufacturingCostId,
          }
        : {
            weight: "",
            length: "",
            color: "",
            gauge: "",
            productId: product._id || "",
            manufacturingCostId: "",
          }
    );
  };

  let totalWeightPreCart = 0;
  let totalPriceCart = 0;

  preCart.forEach(function (item) {
    totalPriceCart += Number(item.manufacturValue) * item.quantity;
  });

  preCart.forEach(function (item) {
    totalWeightPreCart += Number(item.weight.replace(",", ".")) * item.quantity;
  });

  const handleClose = () => {
    clearAllBodyScrollLocks();
    toggle();
  };

  const sortSilverColors = (colors: string[]) => {
    const customOrder = ["plata", "soaked", "rose", "golden"];
    return colors.sort((a, b) => {
      return customOrder.indexOf(a) - customOrder.indexOf(b);
    });
  };

  const childrenViewImage = () => (
    <div>
      <div className="imagePreview">
        <h3>{product.title}</h3>
        <h3 onClick={handleClose} className="imagePreviewClose">
          X
        </h3>
      </div>
      <img
        src={mainImage}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = "https://assets.rtabak.com.ar/rtabak.png";
        }}
      />
    </div>
  );

  return (
    <>
      <TopShadow />
      <section className="itemDetail_container">
        <div className="itemDetail">
          <div className="itemDetail__thumbnail">
            <div className="itemDetail__thumbnail__imageMain">
              {mainImage ? (
                <img
                  src={mainImage}
                  alt="Imagen del producto"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src =
                      "https://assets.rtabak.com.ar/rtabak.png";
                  }}
                />
              ) : null}
              {isOpen && (
                <Modal
                  isOpen={true}
                  toggle={toggle}
                  children={childrenViewImage()}
                />
              )}
            </div>
            <div className="itemDetail__thumbnail__imageList">
              {images.map((im) => {
                return (
                  <img
                    src={im}
                    alt="Imagen del producto"
                    key={im}
                    onClick={() => setMainImage(im)}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src =
                        "https://assets.rtabak.com.ar/rtabak.png";
                    }}
                  />
                );
              })}
            </div>
          </div>
          <div className="itemDetail__data">
            {product.material == "gold" ? (
              <p className="itemDetail__data__gold">Oro 18k</p>
            ) : (
              <p className="itemDetail__data__silver">Plata</p>
            )}

            <h1 className="itemDetail_data_title">{product.title}</h1>
            {product.sku ? (
              <p className="itemDetail__data__sku">{product.sku}</p>
            ) : null}
            {product.description ? (
              <p className="itemDetail__data__description">
                {product.description}
              </p>
            ) : null}
            <AddVariant
              variation={variation}
              labels={labels}
              addOneProduct={addOneProduct}
              handleChange={handleChange}
              colors={
                product.material === "silver"
                  ? sortSilverColors(colors)
                  : colors
              }
              lengths={lengths}
              gauges={gauges}
              restItem={restItem}
              sumItem={sumItem}
              addPreCart={addPreCart}
              handleSelectChange={handleSelectChange}
              handleCreateCustomization={handleCreateCustomization}
              handleEraseCustomization={handleEraseCustomization}
              setIsLoginRequired={setIsLoginRequired}
              isAuth={isAuth}
            />
            {incomplete && (
              <p className="itemDetail_data_msg">
                Seleccione una combinación válida. Si desea proponer una nueva
                variante, escribanos <Link to={"/contact"}>aquí</Link>!
              </p>
            )}
            {exist && (
              <p className="itemDetail_data_msg">
                El producto ya esta en el carrito
              </p>
            )}
            {isLoginRequired && (
              <p className="itemDetail_data_msg">
                Para agregar productos al carrito, primero iniciá sesión{" "}
                <Link to={"/login"} state={{ from: location.pathname }}>
                  haciendo click aquí
                </Link>
              </p>
            )}
            {preCart.length > 0 && (
              <AddedVariants preCart={preCart} removeItem={removeItem} />
            )}
            <div className="itemDetail_cta">
              <div className="itemDetail_cta_btn">
                <button
                  onClick={manageCart}
                  type="button"
                  disabled={!preCart || preCart.length === 0}
                  className={`itemDetail__data__selector__add ${
                    (!preCart || preCart.length === 0) &&
                    `itemDetail__data__selector__disabled`
                  }`}
                >
                  Agregar al carrito
                </button>
                <p className="itemDetail_cta_subtotal">
                  Subtotal:
                  <span>{Number(totalWeightPreCart).toFixed(2)}gr</span>
                  <span>{displayMoney(totalPriceCart)}</span>
                </p>
              </div>
              <div className="itemDetail_alert">
                <Icon iconName="alert_icon" />
                <p>Los pesos son aproximados</p>
              </div>
            </div>
          </div>
        </div>
        {lengths.length > 1 && (
          <Table
            lengths={lengths}
            table={table}
            vertical={labels.gaugeTable}
            horizontal={labels.lenghtTable}
            unit={labels.unit}
          />
        )}
        {carousel && (
          <div className="carousel">
            <h3 className="button_cta">También te puede interesar</h3>
            <div className="carousel_cards">
              <HomeCatalogDesktop sections={carousel} head={true} />
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default ItemDetail;
